export const FLAG_GETTING_ITEM_CATEGORIES = 'FLAG_GETTING_ITEM_CATEGORIES';
export const GET_ITEM_CATEGORIES = 'GET_ITEM_CATEGORIES';
export const CLEAR_ITEM_CATEGORIES = 'CLEAR_ITEM_CATEGORIES';
